"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMsgWithdrawDelegatorReward = exports.msgWithdrawDelegatorRewardTypes = exports.createMsgUndelegate = exports.msgUndelegateTypes = exports.createMsgBeginRedelegate = exports.msgBeginRedelegateTypes = exports.createMsgDelegate = exports.msgDelegateTypes = void 0;
exports.msgDelegateTypes = {
    MsgValue: [
        { name: 'delegator_address', type: 'string' },
        { name: 'validator_address', type: 'string' },
        { name: 'amount', type: 'TypeAmount' },
    ],
    TypeAmount: [
        { name: 'denom', type: 'string' },
        { name: 'amount', type: 'string' },
    ],
};
function createMsgDelegate(delegatorAddress, validatorAddress, amount, denom) {
    return {
        type: 'cosmos-sdk/MsgDelegate',
        value: {
            amount: {
                amount,
                denom,
            },
            delegator_address: delegatorAddress,
            validator_address: validatorAddress,
        },
    };
}
exports.createMsgDelegate = createMsgDelegate;
exports.msgBeginRedelegateTypes = {
    MsgValue: [
        { name: 'delegator_address', type: 'string' },
        { name: 'validator_src_address', type: 'string' },
        { name: 'validator_dst_address', type: 'string' },
        { name: 'amount', type: 'TypeAmount' },
    ],
    TypeAmount: [
        { name: 'denom', type: 'string' },
        { name: 'amount', type: 'string' },
    ],
};
function createMsgBeginRedelegate(delegatorAddress, validatorSrcAddress, validatorDstAddress, amount, denom) {
    return {
        type: 'cosmos-sdk/MsgBeginRedelegate',
        value: {
            amount: {
                amount,
                denom,
            },
            delegator_address: delegatorAddress,
            validator_src_address: validatorSrcAddress,
            validator_dst_address: validatorDstAddress,
        },
    };
}
exports.createMsgBeginRedelegate = createMsgBeginRedelegate;
exports.msgUndelegateTypes = {
    MsgValue: [
        { name: 'delegator_address', type: 'string' },
        { name: 'validator_address', type: 'string' },
        { name: 'amount', type: 'TypeAmount' },
    ],
    TypeAmount: [
        { name: 'denom', type: 'string' },
        { name: 'amount', type: 'string' },
    ],
};
function createMsgUndelegate(delegatorAddress, validatorAddress, amount, denom) {
    return {
        type: 'cosmos-sdk/MsgUndelegate',
        value: {
            amount: {
                amount,
                denom,
            },
            delegator_address: delegatorAddress,
            validator_address: validatorAddress,
        },
    };
}
exports.createMsgUndelegate = createMsgUndelegate;
exports.msgWithdrawDelegatorRewardTypes = {
    MsgValue: [
        { name: 'delegator_address', type: 'string' },
        { name: 'validator_address', type: 'string' },
    ],
};
function createMsgWithdrawDelegatorReward(delegatorAddress, validatorAddress) {
    return {
        type: 'cosmos-sdk/MsgWithdrawDelegationReward',
        value: {
            delegator_address: delegatorAddress,
            validator_address: validatorAddress,
        },
    };
}
exports.createMsgWithdrawDelegatorReward = createMsgWithdrawDelegatorReward;
//# sourceMappingURL=staking.js.map